import { motion } from "framer-motion";
import { MdHourglassEmpty, MdRefresh } from "react-icons/md";
import { I18N_KEYS } from "../languages/PlaceHolder";
import { useTranslation } from "react-i18next";

const NotProfileFound = () => {
    const { t } = useTranslation()
    return (
        <>
            <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 px-6">
                <motion.div
                    initial={{ opacity: 0, y: 30, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ duration: 0.7, ease: "easeOut" }}
                    className="bg-white/90 backdrop-blur-xl shadow-xl rounded-3xl p-10 md:p-14 text-center max-w-xl w-full border border-gray-100"
                >
                    {/* Icon */}
                    <motion.div
                        animate={{ y: [0, -8, 0] }}
                        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                        className="flex justify-center mb-6"
                    >
                        <MdHourglassEmpty className="text-amber-500 text-7xl md:text-8xl" />
                    </motion.div>

                    {/* Heading */}
                    <motion.h2
                        className="text-3xl md:text-4xl font-extrabold text-gray-800 mb-4"
                        initial={{ opacity: 0, y: 15 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                    >
                        {t(I18N_KEYS.PROFILETITLE)}
                    </motion.h2>

                    {/* Divider */}
                    <motion.div
                        initial={{ scaleX: 0 }}
                        animate={{ scaleX: 1 }}
                        transition={{ delay: 0.35, duration: 0.5 }}
                        className="h-[2px] w-20 bg-amber-400 mx-auto mb-6 rounded-full origin-left"
                    />

                    {/* Description */}
                    <motion.p
                        className="text-gray-600 text-base md:text-lg leading-relaxed"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.45, duration: 0.5 }}
                    >
                        {t(I18N_KEYS.PROFILEDES1)}
                        <br />
                        {t(I18N_KEYS.PROFILEDES2)}
                    </motion.p>

                    {/* Refresh Page */}
                    <motion.button
                        onClick={() => window.location.reload()}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="inline-flex items-center gap-2 mt-8 px-5 py-2.5 text-sm md:text-base font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-full transition"
                    >
                        <motion.span
                            whileHover={{ rotate: 180 }}
                            transition={{ duration: 0.4 }}
                            className="flex items-center"
                        >
                            <MdRefresh className="text-xl" />
                        </motion.span>
                        {t(I18N_KEYS.REFRESHPAGE)}
                    </motion.button>
                </motion.div>
            </section>
        </>
    );
}

export default NotProfileFound